<template>
  <div class="message-row" v-if="systemCreating || userCreating"
    :class="{ system: systemCreating, user: userCreating }">
    <div class="author">
      <img v-if="systemCreating" src="@/assets/cb-logo.png" height="50px">
    </div>
    <div class="spinner"></div>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "BotMessage",
  computed: {
    ...mapState({
      userCreating: state => state.chat.userCreating,
      systemCreating: state => state.chat.systemCreating
    })
  }
}
</script>

<style lang="scss" scoped>
::v-deep .logo {
  margin: 0;
  object-fit: fill;
}

::v-deep .spinner-container {
  padding: 0;
}

.message-row {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-top: 20px;
  padding: 8px;

  &.user {
    justify-content: space-between;

    .spinner {
      margin-right: 10px;
    }
  }

  &.system {

    .author {

      img {
        width: 32px;
        height: 32px;
        border: 1px solid #999;
        border-radius: 16px;
        padding: 5px;
        box-shadow: 0px 0px 10px 1px rgb(160 160 160 / 75%);
      }
    }

    .spinner {
      margin-left: 26px;
    }

  }


}
</style>
